import { api } from '@/redux/api/api';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { OptimisticItem } from '@/redux/types/optimistic-item';
import { addItemRecipe } from '@/redux/utils/add-item-recipe';
import { createOptimisticItem } from '@/redux/utils/create-optimistic-item';
import { Organisation } from '@/types/organisation';
import { CreateOrganisationQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchCreateOrganisation: DispatchOptimisticPatchHandler<
  CreateOrganisationQueryArg,
  { optimisticOrg: OptimisticItem<Organisation> }
> = (queryArg, { dispatch }) => {
  const optimisticOrg = createOptimisticItem<Organisation>({
    id: -1,
    name: queryArg.name,
    active: true,
    propertyUnitId: null,
    createdAt: 'pending',
    updatedAt: 'pending',
  });

  const patch = dispatch(
    api.util.updateQueryData(
      'getOrganisations',
      undefined,
      addItemRecipe<Organisation>(optimisticOrg),
    ),
  );

  return { patch, optimisticOrg };
};
